import Skeleton from "react-loading-skeleton";

const SkeletonSessionHistory = () => {
    // Get theme from localStorage (default to 'light' if not set)
    const theme = localStorage.getItem("theme") || "light";

    // Define colors for light and dark themes
    const skeletonColors = theme === "dark"
        ? { baseColor: "#23272F", highlightColor: "#3A3F4B" }
        : { baseColor: "#CECECE", highlightColor: "#E8E8E8" };

    return (
        <div className="px-0 pt-5">
            <div className="border-2 border-[#BDE6FF] rounded-lg">
                {[1, 2, 3, 4].map((item) => (
                    <div
                        key={item}
                        className="flex items-center justify-between p-3 border-b-2 border-[#BDE6FF] last:border-b-0"
                    >
                        <div className="flex flex-col gap-y-0.5 w-full">
                            <Skeleton
                                {...skeletonColors}
                                width="50%"
                                height={11}
                                style={{ borderRadius: "0.25rem" }}
                            />
                            <Skeleton
                                {...skeletonColors}
                                width="80%"
                                height={11}
                                style={{ borderRadius: "0.25rem" }}
                            />
                            <Skeleton
                                {...skeletonColors}
                                width="30%"
                                height={11}
                                style={{ borderRadius: "0.25rem" }}
                            />
                        </div>
                        <Skeleton
                            {...skeletonColors}
                            width={16}
                            height={16}
                            circle={false}
                            style={{ borderRadius: "0.25rem" }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SkeletonSessionHistory;
